import { Injectable } from "@angular/core"
import { Http } from "@angular/http"
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from "rxjs";
import { HttpHelperService } from './helpers/http-helper.service';
import { UserService } from "./user.service";

@Injectable()

export class ReviewService {

    private reviewsSource: BehaviorSubject<any> = new BehaviorSubject([])
	private unactioned: BehaviorSubject<any> = new BehaviorSubject(null)

    constructor(
        private http: Http,
        private httpHelperService: HttpHelperService,
		private userService: UserService
    ) { }

    get Reviews() {
        return this.reviewsSource.asObservable()
    }

	get Unactioned() {
		return this.unactioned.asObservable()
	}

    submitReview(formData) {
        return new Promise((resolve, reject) => {
            const body = formData;
			this.http.post('/api/submitreview', body, { headers: this.httpHelperService.headers(true, UserService.token) }).subscribe((res: any) => {
                var result = res.json()
                if (result) {
                    resolve(result)
                } else {
                    reject(result)
                }
            }, (err: any) => {
                reject(err);
            })
        })
    }

    getReviewsFor(data): Observable<any> {
        const body = data;
        return this.http.post('/api/getreviewsfor', body, { headers: this.httpHelperService.headers(false) })
    }

    getUserReviews(data) {
        return new Promise((resolve, reject) => {
            const body = data;
			this.http.post('/api/review/getuserreviews', body, { headers: this.httpHelperService.headers(true, UserService.token) }).subscribe((res: any) => {
                var result = res.json()
                if (result) {
                    resolve(result)
                } else {
                    reject(result)
                }
            }, (err: any) => {
                reject(err);
            })
        })
    }

    likeOrDislikeReview(data) {
        return new Promise((resolve, reject) => {
            const body = data;
            this.http.post('/api/likeordislikereview', body, { headers: this.httpHelperService.headers(true, UserService.token) }).subscribe((res: any) => {
                var result = res.json()
                if (result) {
                    resolve(result)
                } else {
                    reject(result)
                }
            }, (err: any) => {
                reject(err);
            })
        })
    }

	getUnactioned() {
		this.http.get('/api/review/getunactioned',{ headers: this.httpHelperService.headers(true, UserService.token) }).subscribe((res: any) => {
			this.unactioned.next(res)
		}, err => {
			console.log(err)
		})
    }

    pullReviews(data) {
        const body = data;
        return this.http.post('/api/review/pullreviews', body, { headers: this.httpHelperService.headers(true, UserService.token) })
    }

    approveDisapprove(data) {
        const body = data;
        return this.http.post('/api/review/approvedisapprove', body, { headers: this.httpHelperService.headers(true, UserService.token) })
    }

    checkIfUserReviewed(data) {
        const body = data;
        return this.http.post('/api/review/checkifuserreviewed', body, { headers: this.httpHelperService.headers(true, UserService.token) })
    }

    handleErrors(error: Response) {
        return Observable.throw(error);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/review.service.ts